var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadgeWarning = function SvgBadgeWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.605 2.48c.612-1.089 2.178-1.089 2.79 0l4.463 7.935a1.6 1.6 0 0 1-1.393 2.384h-8.93a1.6 1.6 0 0 1-1.394-2.384zM8.8 10.4a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0M8 4a.8.8 0 0 0-.8.8v2.4a.8.8 0 1 0 1.6 0V4.8A.8.8 0 0 0 8 4",
    clipRule: "evenodd"
  })));
};
export default SvgBadgeWarning;